import React from 'react';
import useReqBalDetails from './useReqBalDetails';
import { ReqBalDetailsDialog, DetailsTable } from './components';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const ReqBalDetail = ({ open, handleClose, ixReqBalSrc }) => {
  const { list, loading, error, errorMessage } = useReqBalDetails({
    ixReqBalSrc,
    open
  });

  return (
    <ReqBalDetailsDialog open={open} handleClose={handleClose}>
      {loading ? (
        <Box display="flex" justifyContent="center" mt={2} mb={2}>
          <CircularProgress size={30} />
        </Box>
      ) : null}

      {error ? (
        <Box mt={2} mb={2}>
          <Alert severity="error">{errorMessage}</Alert>
        </Box>
      ) : null}

      {!loading && list.length === 0 ? (
        <Typography variant="body1" color="primary">
          No Result Found
        </Typography>
      ) : null}

      {!loading && list.length > 0 ? <DetailsTable items={list} /> : null}
    </ReqBalDetailsDialog>
  );
};

export default ReqBalDetail;
